<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="payment-list">
                    <icon name="coins"></icon>
                    รายการเบิก
                </b-nav-item>&nbsp
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: "payment-layout"
    }
</script>

<style scoped>

</style>